import { getSession } from 'next-auth/react';

// Function to push GTM event
export function pushToGTM(eventData = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    try {
      window.dataLayer.push({ ...eventData });
      // console.log(`GTM Event Pushed: ${eventName}`, eventData);
    } catch (error) {
      // console.error('Failed to push to GTM:', error);
    }
  } else {
    console.warn('GTM dataLayer not available');
  }
}

// Function to send data to webhook, ignoring exceptions
export async function pushToWebhook(eventData = {}) {
  try {
    await fetch('/api/events/log-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(eventData)
    });
  } catch (error) {
    console.warn('Failed to send to webhook:', error.message);
  }
}

export const processEvent = async (data = {}) => {
  const { event, event_status, ...rest } = data;
  let { phone } = data;

  if (!phone) {
    const session = await getSession();
    if (session?.user?.phone) {
      phone = session.user.phone;
    }
  }

  const event_payload = {
    event,
    event_status,
    phone: phone?.toString().replace(/^\+/, '') || '',
    timestamp: new Date().toISOString(),
    pageUrl: window.location?.href,
    pageTitle: document?.title,
    source: "WebApp",
    data: rest
  };

  pushToGTM(event_payload);
  await pushToWebhook(event_payload);
};
